module.exports = __webpack_public_path__ + "static/img/person-resource.f2496d37.png";